import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import styles from './Login.module.css';

export default function WachtwoordInstellen() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token    = params.get('token');

  const [wachtwoord, setWachtwoord]     = useState('');
  const [herhaal, setHerhaal]           = useState('');
  const [fout, setFout]                 = useState('');
  const [succes, setSucces]             = useState(false);
  const [laden, setLaden]               = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setFout('');

    if (wachtwoord.length < 8) {
      return setFout('Wachtwoord moet minimaal 8 tekens bevatten.');
    }
    if (wachtwoord !== herhaal) {
      return setFout('Wachtwoorden komen niet overeen.');
    }
    if (!token) {
      return setFout('Ongeldige link. Vraag een nieuwe resetlink aan.');
    }

    setLaden(true);
    try {
      await axios.post('/api/auth/wachtwoord-instellen', { token, wachtwoord });
      setSucces(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setFout(err.response?.data?.error || 'Wachtwoord instellen mislukt.');
    } finally {
      setLaden(false);
    }
  }

  return (
    <div className={styles.pagina}>
      <div className={styles.kaart}>
        <div className={styles.header}>
          <div className={styles.logo}><svg viewBox="0 0 640 586" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',height:'100%'}}>
              <defs>
                <linearGradient id="wlg2" x1="193" y1="476" x2="566" y2="103" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#43d3c5"/><stop offset="1" stopColor="#4088d8"/>
                </linearGradient>
                <linearGradient id="wlg3" x1="97" y1="598" x2="601" y2="95" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#7d8ce8"/><stop offset="1" stopColor="#6d7de0"/>
                </linearGradient>
                <linearGradient id="wlg1" x1="208" y1="470" x2="503" y2="175" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#56c8e9"/><stop offset="1" stopColor="#6a7dde"/>
                </linearGradient>
              </defs>
              <path fill="url(#wlg2)" opacity=".72" d="M291.75,66.48c-37.24,34.2-122.34,178.2-120.62,246.33s85.29,117.24,142.16,133.61,136.12,58.59,184.37,29.29c48.25-29.29,64.62-61.17,49.97-121.48-14.65-60.31-45.66-151.63-56-221.42s-57.72-93.05-84.43-99.08c-26.71-6.03-73.23-6.03-115.45,32.74Z"/>
              <path fill="url(#wlg3)" opacity=".6" d="M103.38,369.06c46.38-90.82,93.21-196.4,252.16-228.02,158.95-31.62,208.88,4.16,233.02,31.62,24.13,27.46,16.64,92.2,3.33,138.06s-10.82,72.49-37.45,107.44c-26.63,34.95-104.78,71.32-172.19,62.16-67.41-9.15-112.42,25.22-206.46,17.73-94.04-7.49-95.3-84.92-72.4-128.99Z"/>
              <path fill="url(#wlg1)" opacity=".72" d="M124.52,221.07c-11.54-77.26,38.12-157.14,191.54-127.38,153.42,29.75,252.91,256.63,274.29,291.03,21.39,34.4,9.3,102.28-25.1,132.96s-63.13,44.13-116.23,34.4c-53.09-9.73-53.81-35.34-122.81-75.51-69-40.16-180.3-112.32-201.69-255.51Z"/>
              <path fill="#fff" d="M387.62,192.25h-50.6l-74.06,210.16h46.2l15.4-46.7,13.2-42.38,24.19-73.51,23.47,73.51,13.2,42.38,14.66,46.7h47.67l-73.33-210.16Z"/>
              <path fill="#fff" d="M361.96,355.71l-2.79-9.63c-1.64-5.66-6.07-10.09-11.73-11.73l-9.63-2.79,9.67-2.85c5.6-1.65,9.98-6.03,11.63-11.63l2.85-9.67,2.8,9.64c1.64,5.65,6.06,10.07,11.71,11.71l9.64,2.8-9.65,2.82c-5.63,1.64-10.02,6.04-11.67,11.67l-2.82,9.65Z"/>
            </svg></div>
          <h1 className={styles.titel}>Wachtwoord instellen</h1>
          <p className={styles.subtitel}>Kies een sterk wachtwoord van minimaal 8 tekens</p>
        </div>

        {succes ? (
          <div style={{
            background: '#D4EDDA', border: '1px solid #A8D5B5', borderRadius: 10,
            padding: 20, textAlign: 'center', color: '#1A6B3C',
            fontFamily: 'Arial, sans-serif', fontWeight: 600
          }}>
            ✓ Wachtwoord ingesteld. U wordt doorgestuurd naar de loginpagina...
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.veld}>
              <label htmlFor="wachtwoord">Nieuw wachtwoord</label>
              <input
                id="wachtwoord"
                type="password"
                value={wachtwoord}
                onChange={e => setWachtwoord(e.target.value)}
                placeholder="Minimaal 8 tekens"
                required
                autoFocus
                autoComplete="new-password"
              />
            </div>
            <div className={styles.veld}>
              <label htmlFor="herhaal">Wachtwoord herhalen</label>
              <input
                id="herhaal"
                type="password"
                value={herhaal}
                onChange={e => setHerhaal(e.target.value)}
                placeholder="Herhaal wachtwoord"
                required
                autoComplete="new-password"
              />
            </div>
            {fout && <div className={styles.fout}>{fout}</div>}
            <button type="submit" className={styles.knop} disabled={laden}>
              {laden ? 'Opslaan...' : 'Wachtwoord instellen'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
